declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

// Container-supplied env vars (named without the REACT_APP_ prefix, e.g. AUTH0_DOMAIN)
// are injected at container start into window._env_ and take priority over
// buildTimeValue, the value CRA bakes into the bundle at build time from .env.
// process.env.REACT_APP_X must stay a literal member expression per call site
// (not a computed process.env[key] lookup) so webpack can statically replace it.
const getEnv = (key: string, buildTimeValue: string): string => window._env_?.[key] || buildTimeValue;

const settings = {
  ENVIRONMENT_IDENTIFIER: getEnv('ENVIRONMENT_IDENTIFIER', 'unset'),
  ENVIRONMENT: getEnv('REACT_APP_ENVIRONMENT', process.env.REACT_APP_ENVIRONMENT as string),
  MAINTENANCE_MODE: getEnv('REACT_APP_MAINTENANCE_MODE', process.env.REACT_APP_MAINTENANCE_MODE as string),
  APPLICATION_INSIGHTS_INSTRUMENTATIONKEY: getEnv('REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATIONKEY', process.env.REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATIONKEY as string),
  APPLICATION_INSIGHTS_INGESTIONENDPOINT: getEnv('REACT_APP_APPLICATION_INSIGHTS_INGESTIONENDPOINT', process.env.REACT_APP_APPLICATION_INSIGHTS_INGESTIONENDPOINT as string),
  APPLICATION_INSIGHTS_LIVEENDPOINT: getEnv('REACT_APP_APPLICATION_INSIGHTS_LIVEENDPOINT', process.env.REACT_APP_APPLICATION_INSIGHTS_LIVEENDPOINT as string),
  VERSION: getEnv('REACT_APP_VER', process.env.REACT_APP_VER as string) || '0.1.0.0',
  API_URL: getEnv('REACT_APP_API_BASE_URL', process.env.REACT_APP_API_BASE_URL as string),
  SHOW_LAYOUT: getEnv('REACT_APP_SHOW_LAYOUT', process.env.REACT_APP_SHOW_LAYOUT as string),
  NCASS_TERMS_AND_CONDITIONS_URL: getEnv('REACT_APP_NCASS_TERMS_AND_CONDITIONS_URL', process.env.REACT_APP_NCASS_TERMS_AND_CONDITIONS_URL as string),
  CASHBACK_TERMS_URL: getEnv('REACT_APP_CASHBACK_TERMS_URL', process.env.REACT_APP_CASHBACK_TERMS_URL as string),
  DIGITAL_FOOD_SAFETY_SYSTEM_URL: getEnv('REACT_APP_DIGITAL_FOOD_SAFETY_SYSTEM_URL', process.env.REACT_APP_DIGITAL_FOOD_SAFETY_SYSTEM_URL as string),
  CONTROL_PANEL_URL: getEnv('REACT_APP_CONTROL_PANEL_URL', process.env.REACT_APP_CONTROL_PANEL_URL as string),
  OFFICE_PHONE_NUMBER: getEnv('REACT_APP_OFFICE_PHONE_NUMBER', process.env.REACT_APP_OFFICE_PHONE_NUMBER as string),
  CONTACT_US_URL: getEnv('REACT_APP_CONTACT_US_URL', process.env.REACT_APP_CONTACT_US_URL as string),
  CALL_BACK_URL: getEnv('REACT_APP_CALL_BACK_URL', process.env.REACT_APP_CALL_BACK_URL as string),
  LEGACY_MVC_URL: getEnv('REACT_APP_LEGACY_MVC_URL', process.env.REACT_APP_LEGACY_MVC_URL as string),
  REMOTE_LOGOUT_URL: getEnv('REACT_APP_REMOTE_LOGOUT_URL', process.env.REACT_APP_REMOTE_LOGOUT_URL as string),
  SHOW_CPA_EXPIRE_BANNER_IN: parseInt(getEnv('REACT_APP_SHOW_CPA_EXPIRE_BANNER_IN', process.env.REACT_APP_SHOW_CPA_EXPIRE_BANNER_IN as string)) as number,

  AUTH0: {
    DOMAIN: getEnv('REACT_APP_AUTH0_DOMAIN', process.env.REACT_APP_AUTH0_DOMAIN as string),
    CLIENT_ID: getEnv('REACT_APP_AUTH0_CLIENT_ID', process.env.REACT_APP_AUTH0_CLIENT_ID as string),
    AUDIENCE: getEnv('REACT_APP_AUTH0_AUDIENCE', process.env.REACT_APP_AUTH0_AUDIENCE as string),
    MEMBER_CHANGE_PASSWORD_URL: getEnv('REACT_APP_AUTH0_MEMBER_CHANGE_PASSWORD_URL', process.env.REACT_APP_AUTH0_MEMBER_CHANGE_PASSWORD_URL as string),
    MEMBER_CHANGE_PASSWORD_DB_CONNECTION: getEnv('REACT_APP_AUTH0_MEMBER_CHANGE_PASSWORD_DB_CONNECTION', process.env.REACT_APP_AUTH0_MEMBER_CHANGE_PASSWORD_DB_CONNECTION as string),
    MEMBER_CHANGE_PASSWORD_CLIENT_ID: getEnv('REACT_APP_AUTH0_MEMBER_CHANGE_PASSWORD_CLIENT_ID', process.env.REACT_APP_AUTH0_MEMBER_CHANGE_PASSWORD_CLIENT_ID as string),
    LOGOUT_URL: getEnv('REACT_APP_AUTH0_LOGOUT_URL', process.env.REACT_APP_AUTH0_LOGOUT_URL as string)
  },

  REWARDS: {
    BOOKER: {
      DEAL_URL: getEnv('REACT_APP_NCASS_BOOKER_DEAL_URL', process.env.REACT_APP_NCASS_BOOKER_DEAL_URL as string),
      FAQ_URL: getEnv('REACT_APP_NCASS_BOOKER_FAQ_URL', process.env.REACT_APP_NCASS_BOOKER_FAQ_URL as string),
    },

    CALOR: {
      APPROVE_REJECTED_CLAIM_CUTOFF_DAYS: parseInt(getEnv('REACT_APP_CALOR_APPROVE_REJECTED_CLAIM_CUTOFF_DAYS', process.env.REACT_APP_CALOR_APPROVE_REJECTED_CLAIM_CUTOFF_DAYS as string)) as number,
      DEAL_URL: getEnv('REACT_APP_CALOR_DEAL_URL', process.env.REACT_APP_CALOR_DEAL_URL as string),
      FAQ_URL: getEnv('REACT_APP_CALOR_FAQ_URL', process.env.REACT_APP_CALOR_FAQ_URL as string),
    },

    BIOPAK: {
      DEAL_URL: getEnv('REACT_APP_BIOPAK_DEAL_URL', process.env.REACT_APP_BIOPAK_DEAL_URL as string),
      FAQ_URL: getEnv('REACT_APP_BIOPAK_FAQ_URL', process.env.REACT_APP_BIOPAK_FAQ_URL as string),
    },

    NISBETS: {
      DEAL_URL: getEnv('REACT_APP_NISBETS_DEAL_URL', process.env.REACT_APP_NISBETS_DEAL_URL as string),
      FAQ_URL: getEnv('REACT_APP_NISBETS_FAQ_URL', process.env.REACT_APP_NISBETS_FAQ_URL as string),
    },
  },

  HELP_VIDEOS: {
    FOOD_SAFETY_ID: getEnv('REACT_APP_HELP_VIDEOS_FOOD_SAFETY_ID', process.env.REACT_APP_HELP_VIDEOS_FOOD_SAFETY_ID as string),
    H_AND_S_FIRE_ID: getEnv('REACT_APP_HELP_VIDEOS_H_AND_S_FIRE_ID', process.env.REACT_APP_HELP_VIDEOS_H_AND_S_FIRE_ID as string),
    HEALTH_SAFETY_POLICY_ID: getEnv('REACT_APP_HELP_VIDEOS_HEALTH_SAFETY_POLICY_ID', process.env.REACT_APP_HELP_VIDEOS_HEALTH_SAFETY_POLICY_ID as string),
    COSHH_ASSESSMENT_ID: getEnv('REACT_APP_HELP_VIDEOS_COSHH_ASSESSMENT_ID', process.env.REACT_APP_HELP_VIDEOS_COSHH_ASSESSMENT_ID as string),
  },

  TRADING_UNITS: {
    OTHER_BUSINESS_TYPE_ID: getEnv('REACT_APP_TRADING_UNITS_OTHER_BUSINESS_TYPE_ID', process.env.REACT_APP_TRADING_UNITS_OTHER_BUSINESS_TYPE_ID as string)
  },

  REALLY_AWESOME_UNIT_AUTOCREATE: {
    PRODUCT_NAME: getEnv('REACT_APP_REALLY_AWESOME_PRODUCT_NAME', process.env.REACT_APP_REALLY_AWESOME_PRODUCT_NAME as string),
    BUSINESS_TYPE_ID: getEnv('REACT_APP_REALLY_AWESOME_BUSINESS_TYPE', process.env.REACT_APP_REALLY_AWESOME_BUSINESS_TYPE as string),
    PREPARED_IN_KITCHEN: getEnv('REACT_APP_REALLY_AWESOME_PREPARED_IN_KITCHEN', process.env.REACT_APP_REALLY_AWESOME_PREPARED_IN_KITCHEN as string),
    FOOD_TYPES: getEnv('REACT_APP_REALLY_AWESOME_BUSINESS_FOOD_TYPES', process.env.REACT_APP_REALLY_AWESOME_BUSINESS_FOOD_TYPES as string),
    EQUIPMENT_TYPES: getEnv('REACT_APP_REALLY_AWESOME_BUSINESS_EQUIPMENT_TYPES', process.env.REACT_APP_REALLY_AWESOME_BUSINESS_EQUIPMENT_TYPES as string)
  },

  MEMBERSHIP_HUB: {
    ASSET_BASE: getEnv('REACT_APP_MEMBERSHIP_HUB_ASSET_BASE', process.env.REACT_APP_MEMBERSHIP_HUB_ASSET_BASE as string),
  },

  PAYMENTS: {
    TRANSACTION_GATEWAY: getEnv('REACT_APP_TRANSACTION_GATEWAY', process.env.REACT_APP_TRANSACTION_GATEWAY as string),
    DISABLE_PAYMENTS: getEnv('REACT_APP_DISABLE_PAYMENTS', process.env.REACT_APP_DISABLE_PAYMENTS as string)
  },

  TRAINING: {
    TRAINING_WEBSITE: getEnv('REACT_APP_TRAINING_WEBSITE', process.env.REACT_APP_TRAINING_WEBSITE as string),
    TRAINEE_PHOTO_BASE_URL: getEnv('REACT_APP_TRAINEE_PHOTO_BASE_URL', process.env.REACT_APP_TRAINEE_PHOTO_BASE_URL as string)
  },

  SOCIAL_MEDIA: {
    ACCEPTABLE_FACEBOOK_URLS: getEnv('REACT_APP_ACCEPTABLE_FACEBOOK_URLS', process.env.REACT_APP_ACCEPTABLE_FACEBOOK_URLS as string),
    ACCEPTABLE_INSTAGRAM_URLS: getEnv('REACT_APP_ACCEPTABLE_INSTAGRAM_URLS', process.env.REACT_APP_ACCEPTABLE_INSTAGRAM_URLS as string),
    ACCEPTABLE_YOUTUBE_URLS: getEnv('REACT_APP_ACCEPTABLE_YOUTUBE_URLS', process.env.REACT_APP_ACCEPTABLE_YOUTUBE_URLS as string),
    ACCEPTABLE_TIKTOK_URLS: getEnv('REACT_APP_ACCEPTABLE_TIKTOK_URLS', process.env.REACT_APP_ACCEPTABLE_TIKTOK_URLS as string),
    ACCEPTABLE_X_URLS: getEnv('REACT_APP_ACCEPTABLE_X_URLS', process.env.REACT_APP_ACCEPTABLE_X_URLS as string),
    ACCEPTABLE_LINKEDIN_URLS: getEnv('REACT_APP_ACCEPTABLE_LINKEDIN_URLS', process.env.REACT_APP_ACCEPTABLE_LINKEDIN_URLS as string),
  },

  WORK_OPPS: {
      REPORT_WORK_OPPS_EMAIL: getEnv('REACT_APP_REPORT_WORK_OPPS_EMAIL', process.env.REACT_APP_REPORT_WORK_OPPS_EMAIL as string),
      WORK_OPPS_GUIDE_TENDERING: getEnv('REACT_APP_WORK_OPPS_GUIDE_TENDERING', process.env.REACT_APP_WORK_OPPS_GUIDE_TENDERING as string),
      WORK_OPPS_GUIDE_CHARGING: getEnv('REACT_APP_WORK_OPPS_GUIDE_CHARGING', process.env.REACT_APP_WORK_OPPS_GUIDE_CHARGING as string),
      WORK_OPPS_GUIDE_AGREEMENT: getEnv('REACT_APP_WORK_OPPS_GUIDE_AGREEMENT', process.env.REACT_APP_WORK_OPPS_GUIDE_AGREEMENT as string),
      WORK_OPPS_PRIVACY_POLICY: getEnv('REACT_APP_WORK_OPPS_PRIVACY_POLICY', process.env.REACT_APP_WORK_OPPS_PRIVACY_POLICY as string),
      WORK_OPPS_CODE_OF_CONDUCT: getEnv('REACT_APP_WORK_OPPS_CODE_OF_CONDUCT', process.env.REACT_APP_WORK_OPPS_CODE_OF_CONDUCT as string)
  }
};

export default settings;


